import { useQuery } from '@tanstack/react-query';
import { getAuditTrail } from './auditLogs.api';
import { auditLogsQueryKeys } from './queryKeys';
import { AuditLogDto } from '@aphp-ema/common/audit';

export const useGetAuditTrail = (resourceId: string) => {
  return useQuery<AuditLogDto[], Error>({
    queryKey: auditLogsQueryKeys.trail(resourceId),
    queryFn: () => getAuditTrail(resourceId),
    enabled: !!resourceId,
  });
};
